/**
 * Security Module - Basic content protection and robustness
 */

/**
 * Setup content protection measures
 * @returns {void}
 */
export function setupSecurity() {
  // Block right click except for inputs
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  });

  // Block dragging images
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
    }
  }, false);
}

/**
 * Utility to escape HTML and prevent XSS
 * @param {string} str - The string to escape
 * @returns {string} - The escaped string
 */
export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  return String(str).replace(/[&<>'"]/g,
    tag => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#39;',
      '"': '&quot;'
    }[tag] || tag)
  );
}

/**
 * Handle CSS async loading to avoid CSP inline handler violations
 * @returns {void}
 */
export function setupAsyncCSS() {
  const loadCSS = (link) => {
    link.media = 'all';
  };

  const links = document.querySelectorAll('link[media="print"][data-async]');
  links.forEach(link => {
    // Check if link is already loaded (link.sheet will be present for loaded stylesheets)
    // Note: 'complete' property is for images, not link elements
    if (link.sheet) {
      loadCSS(link);
    } else {
      link.addEventListener('load', () => loadCSS(link), { once: true });
    }
  });
}
